var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDashedCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BinDrop/Icon/dashed-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.8287 10.2435C20.9411 10.8116 21 11.3989 21 12C21 12.6011 20.9411 13.1884 20.8287 13.7565M19.4841 6.99946C18.827 6.018 17.982 5.17298 17.0005 4.51591M13.7565 3.17131C13.1884 3.05892 12.6011 3 12 3C11.3989 3 10.8116 3.05892 10.2435 3.17131M6.99946 4.51591C6.018 5.17298 5.17298 6.018 4.51591 6.99946M3.17131 10.2435C3.05892 10.8116 3 11.3989 3 12C3 12.6011 3.05892 13.1884 3.17131 13.7565M4.51591 17.0005C5.17298 17.982 6.018 18.827 6.99946 19.4841M10.2435 20.8287C10.8116 20.9411 11.3989 21 12 21C12.6011 21 13.1884 20.9411 13.7565 20.8287M17.0005 19.4841C17.982 18.827 18.827 17.982 19.4841 17.0005",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#BFBFBF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDashedCircle);
export default __webpack_public_path__ + "static/media/icon-dashed-circle.86bee2f9234bbca275499b9e9072e2e9.svg";
export { ForwardRef as ReactComponent };